module.exports = __webpack_public_path__ + "img/scan_extraction.b917356f.svg";